import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-left">
          <div className="footer-logo">
            <img src="/images/pg_main_logo.webp" alt="Phantom Ghosts Logo" loading="lazy" />
          </div>
          <div className="footer-brand">
            <span className="footer-brand-name">Phantom Ghosts</span>
            <span className="footer-brand-tagline">Valorant Premier Legends</span>
          </div>
        </div>

        <nav className="footer-nav" aria-label="Footer navigation">
          <a href="https://www.instagram.com/pgesports.vpl/" target="_blank" rel="noreferrer" className="footer-nav-item">Instagram</a>
          <a href="https://www.youtube.com/@brahmiwarrior6062" target="_blank" rel="noreferrer" className="footer-nav-item">YouTube</a>
          <a href="https://discord.gg/J3XpUBKsQa" target="_blank" rel="noreferrer" className="footer-nav-item">Discord</a>
          <Link to="/privacy" className="footer-nav-item">Privacy</Link>
        </nav>

        <span className="footer-copy">© {new Date().getFullYear()} PG Esports. All rights reserved.</span>

      </div>
    </footer>
  );
};

export default Footer;